import Fuse from "fuse.js";
import { castEvent } from "applesauce-common/casts";

import { WifiNetwork } from "../casts/wifi-network";
import { WIFI_NETWORK_KIND } from "../const";
import { eventStore } from "./stores";

export type WifiSearchItem = {
  id: string;
  network: WifiNetwork;
  ssid?: string;
  name?: string;
  about: string;
};

export const wifiSearch = new Fuse<WifiSearchItem>([], {
  keys: ["ssid", "name"],
});

eventStore.filters({ kinds: [WIFI_NETWORK_KIND] }).subscribe((event) => {
  const network = castEvent(event, WifiNetwork, eventStore);

  wifiSearch.add({
    id: event.id,
    network,
    ssid: network.ssid,
    name: network.name,
    about: network.description,
  });
});
